// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import router from './router'
import uploader from 'vue-simple-uploader'
Vue.use(uploader)
import ElementUI from 'element-ui'
// import WUI from 'warm-ui/libs/warm.common.js' // 引入组件库
import App from './App'
// import 'warm-ui/libs/warm.css' // 引入样式库
// Vue.use(WUI)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.config.devtools = true
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js